import React from 'react';

import type {IntlShape} from 'react-intl';

import type {ContentShape} from '@edume/magnificent';

import ToolbarButtons from '../ToolbarButtons';

type UploadPreviewStepArgs = {
  type: 'image' | 'video';
  body: React.ReactNode;
  isRemovingEnabled: boolean;
  onClose: () => void;
  onRemove: () => void;
  startUpload: (files: File[]) => void;
  hasNewUpload?: boolean;
  goToLibrary: () => void;
  intl: IntlShape;
};

const getUploadPreviewStep = ({
  intl,
  type,
  isRemovingEnabled,
  body,
  onClose,
  startUpload,
  onRemove,
  hasNewUpload,
  ...propsRest
}: UploadPreviewStepArgs) =>
  ({
    iconUrl: hasNewUpload ? '/resources/img/38_tick.svg' : undefined,
    title: intl.formatMessage(
      {
        id: hasNewUpload
          ? 'UploadModal.successTitle'
          : 'UploadModal.changeMediaTitle',
      },
      {type}
    ),
    body,
    buttons: [
      {
        type: 'primary',
        onClick: onClose,
        text: intl.formatMessage({id: 'Button.okay'}),
        dataAutomation: 'done-button',
      },
    ],
    bottomLeftContent: {
      type: 'element',
      element: (
        <ToolbarButtons
          type={type}
          onRemove={onRemove}
          onReplace={startUpload}
          isRemovingEnabled={isRemovingEnabled}
          {...propsRest}
        />
      ),
    },
  } satisfies ContentShape);

export default getUploadPreviewStep;
